import React, { useState, useEffect } from "react";
import { Tabs, Input, Button } from "antd";
import FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import NetworkService from "./services/NetworkService";
import AnotherTable from "./components/AnotherTable";
import CustomModal from "./components/ActiveCCModal";
import jsPDF from "jspdf";
import { activeCC, activeREC, activeSGREC } from "./assets/tableViews";
import "react-pdf/dist/esm/Page/TextLayer.css";
import ActiveRECModal from "./components/ActiveRECModal";
import ActiveSGRECModal from "./components/ActiveSGRECModal";
import RetirementModal from "./components/RetirementModal";
import { useAtom } from "jotai";
import { selectedRecord, retirementQuantity, menuDisabledAtom, accessTokenAtom } from "./atoms";
import { RetirementResidential, RetirementCnI, RetirementSMB } from "./assets/retirementView";
import {
  RECRetirementResidential,
  RECRetirementSMB,
  RECRetirementCnI,
  SGRECRetirementCnI,
} from "./assets/retirementRecView";
import { CCRetirementBacklog, RECRetirementBacklog } from "./assets/retirementBacklog";
import { useMsal } from "@azure/msal-react";
import { graphrequest, loginRequest } from "./authConfig";
import { callMsGraph, getGroups } from "./graph";
import NotInGroup from "./components/NotInGroup";
import "./App.css";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

function App() {
  const [currentTabTitle, setCurrentTabTitle] = useState("Active CC");
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  const [ccData, setCCData] = useState([]);
  const [retCCRESData, setretCCRESData] = useState([]);
  const [retCCSMBData, setretCCSMBData] = useState([]);
  const [retCCCnIData, setretCCCnIData] = useState([]);
  const [retRECRESData, setretRECRESData] = useState([]);
  const [retRECSMBData, setretRECSMBData] = useState([]);
  const [retRECCnIData, setretRECCnIData] = useState([]);
  const [retSGRECCnIData, setretSGRECCnIData] = useState([]);
  const [retirementBacklog, setRetirementBacklog] = useState([]);
  const [retirementBacklogREC, setRetirementBacklogREC] = useState([]);
  const [retirementBacklogSGREC, setRetirementBacklogSGREC] = useState([]);
  const [retCCData, setretCCData] = useState([]);
  const [retRECData, setRETRECData] = useState([]);
  const [RetSgRecData, setRetSgRecData] = useState([]);
  const [recData, setRecData] = useState([]);
  const [sgrecData, setSGRecData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [retirementDisplay, setRetirementDisplay] = useState(false);
  const [currentRecord, setCurrentRecord] = useAtom(selectedRecord);
  const [retirementValue, setRetirementValue] = useAtom(retirementQuantity);
  const [menuDisable, setMenuDisable] = useAtom(menuDisabledAtom);
  const [typesOfCC, setTypesOfCC] = useState([]);
  const [energyPlans, setEnergyPlans] = useState([]);
  const [availableQuantityDashboard, setAvailabledashboard] = useState([]);
  const [accessToken, setAPIToken] = useState();
  const [group, setGroup] = useState();
  const [accessAtom, setAPIAtom] = useAtom(accessTokenAtom);
  const { instance, accounts } = useMsal();

  useEffect(() => {
    async function getData(tok) {
      const networkServiceObj = new NetworkService();
      networkServiceObj
        .getActiveProjectsService(tok)
        .then((res) => {
          setCCData([...ccData, res.data?.filter((x) => x.typeOfGreenInstrument === "CC")]);
          console.log("A", ccData);
          setSGRecData([
            ...sgrecData,
            res.data?.filter((x) => x.typeOfGreenInstrument === "SGREC"),
          ]);
          setRecData([...recData, res.data?.filter((x) => x.typeOfGreenInstrument === "REC")]);
        })
        .then(() => {
          setCurrentData(ccData[0]);
          networkServiceObj.getActiveCCService(tok).then((res) => {
            const ccTypes2 = res.data.reduce((acc, item) => {
              return {
                ...acc,
                [item.typeOfGreenInstrument]: {
                  id: item.id,
                  categories: item.categories.split(`,`),
                },
              };
            }, {});
            setTypesOfCC(ccTypes2);
          });
        })
        .then(() => {
          networkServiceObj.getEnergyPlanService(tok).then((res) => {
            setEnergyPlans(res.data);
          });
        })
        .then(() => setLoading(false));
    }

    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        console.log("CH", response);

        setLoading(true);
        setAPIToken(response.accessToken);
        setAPIAtom(response.accessToken);
        getData(response.accessToken);
      })
      .then(() => {
        instance
          .acquireTokenSilent({
            ...graphrequest,
            account: accounts[0],
          })
          .then((response) => {
            console.log("CH", response);
            callMsGraph(response.accessToken).then((responseGraph) => {});
            getGroups(response.accessToken).then((responsex) => {
              setGroup(responsex.value[0]);
              if (!responsex.value.includes(process.env.REACT_APP_Graph_Group_ID)) {
                setMenuDisable(true);
              }
            });
          });
      });
  }, []);

  function getretirement() {
    let bearer = `Bearer ${accessToken}`;
    const settings = {
      method: "GET",
      headers: {
        Authorization: bearer,
      },
    };
    setCurrentData(null);
    fetch(`${process.env.REACT_APP_API_URL}Retirement`, settings)
      .then((res) => res.json())
      .then(
        (result) => {
          setretCCCnIData([
            ...retCCCnIData,
            result.result.data.filter(
              (x) => x.retirementType === "CC" && x.customerType === "Business User"
            ),
          ]);
          setretCCRESData([
            ...retCCRESData,
            result.result.data.filter(
              (x) => x.retirementType === "CC" && x.customerType === "Residential User"
            ),
          ]);
          setretCCSMBData([
            ...retCCSMBData,
            result.result.data.filter(
              (x) => x.retirementType === "CC" && x.customerType === "SMB User"
            ),
          ]);
          setretRECRESData([
            ...retRECRESData,
            result.result.data.filter(
              (x) => x.retirementType === "REC" && x.customerType === "Residential User"
            ),
          ]);
          setretRECSMBData([
            ...retRECSMBData,
            result.result.data.filter(
              (x) => x.retirementType === "REC" && x.customerType === "SMB User"
            ),
          ]);
          setretRECCnIData([
            ...retRECCnIData,
            result.result.data.filter(
              (x) => x.retirementType === "REC" && x.customerType === "Business User"
            ),
          ]);
          setretSGRECCnIData([
            ...retSGRECCnIData,
            result.result.data.filter(
              (x) => x.retirementType === "SGREC" && x.customerType === "Business User"
            ),
          ]);
        },
        (error) => {
          setLoading(true);
        }
      )
      .then(() => {
        getColumns();
      });
  }

  function getretirementBackLog() {
    let bearer = `Bearer ${accessToken}`;
    const settings = {
      method: "GET",
      headers: {
        Authorization: bearer,
      },
    };
    fetch(`${process.env.REACT_APP_API_URL}RetirementBacklog/GetAllRetirementBacklog`, settings)
      .then((res) => res.json())
      .then(
        (result) => {
          setRetirementBacklog([
            ...retirementBacklog,
            result.data.filter((x) => x.retirementType === "CC"),
          ]);
          setRetirementBacklogREC([
            ...retirementBacklogREC,
            result.data.filter((x) => x.retirementType === "REC"),
          ]);
          setRetirementBacklogSGREC([
            ...retirementBacklogSGREC,
            result.data.filter((x) => x.retirementType === "SGREC"),
          ]);
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setLoading(true);
        }
      );
  }

  const handleTabChange = (key) => {
    const currentTab = secondTab.find((t) => t.key === key);
    if (!currentTab) return;
    const tabLabel = currentTab.label;
    setCurrentTabTitle(tabLabel);

    if (
      (key == 2 || key == 3 || key == 5 || key == 6 || key == 8) &&
      retCCCnIData[0] == null &&
      retCCRESData[0] == null &&
      retCCSMBData[0] == null &&
      retRECRESData[0] == null &&
      retRECSMBData[0] == null &&
      retRECCnIData[0] == null &&
      retSGRECCnIData[0] == null
    ) {
      getretirement();
    }
    if (key == 9 || key == 10 || key == 11) {
      getretirementBackLog();
    }
  };

  const handleLogout = () => {
    instance
      .logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/",
      })
      .then(() => {
        setMenuDisable(false);
      });
  };

  const GetSpecificModal = (props) => {
    let { currentTab } = props;

    switch (currentTab) {
      case "Active CC":
        return <CustomModal currentTabTitle={currentTabTitle} ccTypes={typesOfCC.CC} />;
      case "Active REC":
        return <ActiveRECModal currentTabTitle={currentTabTitle} ccTypes={typesOfCC.REC} />;
      case "Active SG REC":
        return <ActiveSGRECModal currentTabTitle={currentTabTitle} ccTypes={typesOfCC.SGREC} />;
      default:
        return null;
    }
  };

  const getDateToday = () => {
    var date = new Date();

    // Get day, month, and year components from the Date object
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    day = day < 10 ? "0" + day : day;
    month = month < 10 ? "0" + month : month;

    var formattedDate = day + "" + month + "" + year;

    return formattedDate;
  };

  const handleExportExcel = async () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const dateToday = getDateToday();
    const fileName = `${currentTabTitle}_${dateToday}`;
    const cols = getColumns();
    const innerHTML = document.querySelector(".test-data").innerHTML;
    const currentTableData = JSON.parse(innerHTML);

    let editedTableData = currentTableData.map((obj) => {
      const updatedObject = {};
      cols.forEach((obj2) => {
        if (obj2.header !== "Table Operation") {
          let data = obj[obj2.dataKey];
          if (isIsoDate(data)) {
            const date = new Date(data);
            // Get the day, month, and year from the date object
            const day = date.getDate().toString().padStart(2, "0");
            const month = (date.getMonth() + 1).toString().padStart(2, "0"); // month is 0-indexed
            const year = date.getFullYear().toString();
            data = `${day}-${month}-${year}`;
          }
          updatedObject[obj2.header] = data;
        }
      });
      return updatedObject;
    });

    const ws = XLSX.utils.json_to_sheet(editedTableData);

    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const handleExportAllExcel = async (fileName) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const myPromise = new Promise((resolve, reject) => {
      getColumns();
      setTimeout(() => {
        resolve(currentData);
      }, 300);
    });

    myPromise.then((res) => {
      const ws = XLSX.utils.json_to_sheet(res);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    });
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const getColumns = () => {
    switch (currentTabTitle) {
      case "Active CC":
        setCurrentData(ccData[0]);
        return activeCC.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Active REC":
        setCurrentData(recData[0]);
        return activeREC.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Active SG REC":
        setCurrentData(sgrecData[0]);
        return activeREC.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Retired CC for Residential":
        setCurrentData(retCCRESData[0]);
        return RetirementResidential.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Retired CC for SMB":
        setCurrentData(retCCSMBData[0]);
        return RetirementSMB.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Retired CC for C&I":
        setCurrentData(retCCCnIData[0]);
        return RetirementCnI.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Retired REC for Residential":
        setCurrentData(retRECRESData[0]);
        return RECRetirementResidential.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Retired REC for SMB":
        setCurrentData(retRECSMBData[0]);
        return RECRetirementSMB.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Retired REC for C&I":
        setCurrentData(retRECCnIData[0]);
        return RECRetirementCnI.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Retired SG REC":
        setCurrentData(retSGRECCnIData[0]);
        return SGRECRetirementCnI.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Backlog CC":
        setCurrentData(retirementBacklog[0]);
        return CCRetirementBacklog.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Backlog REC":
        setCurrentData(retirementBacklogREC[0]);
        return RECRetirementBacklog.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Backlog SG REC":
        setCurrentData(retirementBacklogSGREC[0]);
        return SGRECRetirementCnI.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      default:
        return null;
    }
  };

  // Currently, there is only 1 dummy data (and 1 default column).
  // Meaning, regardless of which Tab is opened, whatever is
  // displayed in the table will be exported INCLUDING all the Object
  // keys found in the dummy data.

  function isIsoDate(str) {
    return (
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{0,3}$/.test(str) ||
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(str)
    );
  }

  const handleExportPdf = () => {
    const innerHTML = document.querySelector(".test-data").innerHTML;
    const dateToday = getDateToday();
    const fileName = `${currentTabTitle}_${dateToday}`;
    const currentTableData = JSON.parse(innerHTML);

    const newData = currentTableData.map((data) => {
      for (const property in data) {
        if (isIsoDate(data[property])) {
          const date = new Date(data[property]);
          // Get the day, month, and year from the date object
          const day = date.getDate().toString().padStart(2, "0");
          const month = (date.getMonth() + 1).toString().padStart(2, "0"); // month is 0-indexed
          const year = date.getFullYear().toString();
          data[property] = `${day}-${month}-${year}`;
        }
      }
      return data;
    });

    const width = 1400;
    const height = 581.703125;
    require("jspdf-autotable");
    const report = new jsPDF("landscape", "pt", "a3");
    // get all the header columns of the table
    // do not include the "Tabe Operation" column
    // const cols = activeCC.map(c => ({ title: c.title }))
    const cols2 = getColumns();
    // cols.pop()
    // cols2.pop()
    const indexOfObject = cols2.findIndex((object) => {
      return object.header === "Table Operation";
    });
    if (cols2.find((e) => e.header === "Table Operation")) {
      cols2.splice(indexOfObject, 1);
    }
    // Flatten each object's values
    // do not include the first element, "key"
    const temp = currentTableData.map((d) => {
      const x = Object.values(d);
      return x;
    });

    const xOffset = report.internal.pageSize.width / 2;
    report.text(currentTabTitle, xOffset, 25, { align: "center" });
    report.autoTable({
      // tableWidth:'wrap',
      body: newData,
      columns: cols2,
      columnStyles:
        currentTabTitle === "Active CC" ||
        currentTabTitle === "Active REC" ||
        currentTabTitle === "Active SG REC"
          ? {
              0: { cellWidth: "auto" },
              1: { cellWidth: "auto" },
              2: { cellWidth: "auto" },
              3: { cellWidth: "auto" },
              4: { cellWidth: "auto" },
              5: { cellWidth: "auto" },
              6: { cellWidth: 200 },
              7: { cellWidth: 250 },
              8: { cellWidth: "auto" },
              9: { cellWidth: "auto" },
              10: { cellWidth: "auto" },
            }
          : {},
    });
    report.save(fileName + ".pdf");
  };

  const handleExportAllPdf = (fileName) => {
    require("jspdf-autotable");
    const myPromise = new Promise((resolve, reject) => {
      var cols2 = getColumns();

      resolve([cols2, currentData]);
    });
  };

  const secondTab = [
    {
      key: 1,
      label: "Active CC",
      children: ccData[0] != null && (
        <AnotherTable
          defaultColumns={activeCC}
          dummyData={ccData[0]}
          label={"CC"}
          token={accessToken}
        ></AnotherTable>
      ),
      forcedRender: true,
    },
    {
      key: 2,
      label: "Retired CC for Residential",
      children: retCCRESData[0] != null && (
        <AnotherTable
          defaultColumns={RetirementResidential}
          dummyData={retCCRESData[0]}
          label={"CC"}
          token={accessToken}
        ></AnotherTable>
      ),
      forcedRender: true,
    },
    {
      key: 12,
      label: "Retired CC for SMB",
      children: retCCSMBData[0] != null && (
        <AnotherTable
          defaultColumns={RetirementSMB}
          dummyData={retCCSMBData[0]}
          label={"CC"}
          token={accessToken}
        ></AnotherTable>
      ),
      forcedRender: true,
    },
    {
      key: 3,
      label: "Retired CC for C&I",
      children: retCCCnIData[0] != null && (
        <AnotherTable
          defaultColumns={RetirementCnI}
          dummyData={retCCCnIData[0]}
          label={"CC"}
          token={accessToken}
        ></AnotherTable>
      ),
      forcedRender: true,
    },
    {
      key: 4,
      label: "Active REC",
      children: recData[0] != null && (
        <AnotherTable
          defaultColumns={activeREC}
          dummyData={recData[0]}
          label={"REC"}
          token={accessToken}
        ></AnotherTable>
      ),
      forcedRender: true,
    },
    {
      key: 5,
      label: "Retired REC for Residential",
      children: retRECRESData[0] != null && (
        <AnotherTable
          defaultColumns={RECRetirementResidential}
          dummyData={retRECRESData[0]}
          label={"REC"}
          token={accessToken}
        ></AnotherTable>
      ),
      forcedRender: true,
    },
    {
      key: 13,
      label: "Retired REC for SMB",
      children: retRECSMBData[0] != null && (
        <AnotherTable
          defaultColumns={RECRetirementSMB}
          dummyData={retRECSMBData[0]}
          label={"REC"}
          token={accessToken}
        ></AnotherTable>
      ),
      forcedRender: true,
    },
    {
      key: 6,
      label: "Retired REC for C&I",
      children: retRECCnIData[0] != null && (
        <AnotherTable
          defaultColumns={RECRetirementCnI}
          dummyData={retRECCnIData[0]}
          label={"REC"}
          token={accessToken}
        ></AnotherTable>
      ),
      forcedRender: true,
    },
    {
      key: 7,
      label: "Active SG REC",
      children: sgrecData[0] != null && (
        <AnotherTable
          defaultColumns={activeSGREC}
          dummyData={sgrecData[0]}
          label={"SGREC"}
          token={accessToken}
        ></AnotherTable>
      ),
      forcedRender: true,
    },
    {
      key: 8,
      label: "Retired SG REC",
      children: retSGRECCnIData[0] != null && (
        <AnotherTable
          defaultColumns={SGRECRetirementCnI}
          dummyData={retSGRECCnIData[0]}
          label={"SGREC"}
          token={accessToken}
        ></AnotherTable>
      ),
      forcedRender: true,
    },
    {
      key: 9,
      label: "Backlog CC",
      children: retirementBacklog[0] != null && (
        <AnotherTable
          defaultColumns={CCRetirementBacklog}
          dummyData={retirementBacklog[0]}
          label={"CC"}
          token={accessToken}
        ></AnotherTable>
      ),
      forcedRender: true,
    },
    {
      key: 10,
      label: "Backlog REC",
      children: retirementBacklogREC[0] != null && (
        <AnotherTable
          defaultColumns={RECRetirementBacklog}
          dummyData={retirementBacklogREC[0]}
          label={"CC"}
          token={accessToken}
        ></AnotherTable>
      ),
      forcedRender: true,
    },
    {
      key: 11,
      label: "Backlog SG REC",
      children: retirementBacklogSGREC[0] != null && (
        <AnotherTable
          defaultColumns={SGRECRetirementCnI}
          dummyData={retirementBacklogSGREC[0]}
          label={"CC"}
          token={accessToken}
        ></AnotherTable>
      ),
      forcedRender: true,
    },
  ];

  const viewPdf = (pdfData) => {
    // using Java Script method to get PDF file
    fetch(
      "https://gcs-dev-web.azurewebsites.net/api/Certificate/DownloadCertificate?certificateNo=C230000064&mssl=1234567890&accountNo=GC3699933S"
    ).then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "SamplePDF.pdf";
        alink.click();
      });
    });
  };

  return (
    <div className="App">
      {/* <h5 className="card-title">Welcome {accounts[0].name}</h5> */}
      {menuDisable === false && (
        <div className="row" style={{ width: "100%" }}>
          {(currentTabTitle === "Active CC" ||
            currentTabTitle === "Active REC" ||
            currentTabTitle === "Active SG REC") && (
            <div
              className="col-6 d-flex align-items-center justify-content-start"
              style={{ marginLeft: 20 + "px" }}
            >
              <h6 className="my-0 me-4">Retirement Quantity</h6>
              <Input
                type="number"
                className="w-25"
                onInput={(e) => setRetirementValue(e.target.value)}
              />

              <Button
                key="retirement"
                onClick={() => {
                  setRetirementDisplay(true);
                }}
                disabled={
                  currentRecord == null
                    ? true
                    : retirementValue <= 0
                      ? true
                      : currentRecord.availableQuantity < retirementValue
                        ? true
                        : false
                }
              >
                {/* {console.log(currentRecord)}
              {currentRecord==null?true:(currentRecord.totalQuantity<retirementValue)?true:false} */}
                Batch Retirement
              </Button>
            </div>
          )}

          <div className="col d-flex justify-content-end">
            {/* <CustomModal currentTabTitle={currentTabTitle}></CustomModal> */}
            <RetirementModal
              energyPlans={energyPlans}
              display={retirementDisplay}
              currentTab={currentTabTitle}
              setDisplay={() => {
                setRetirementDisplay();
              }}
              token={accessToken}
            />

            {loading === false && <GetSpecificModal currentTab={currentTabTitle} />}
            <Button key="excel" onClick={() => handleExportExcel()}>
              Export Excel
            </Button>
            <Button key="pdf" onClick={() => handleExportPdf()}>
              Export PDF
            </Button>
          </div>
        </div>
      )}

      {menuDisable === true ? <NotInGroup handleLogout={() => handleLogout()} /> : null}

      {loading === false && menuDisable === false && (
        <Tabs
          defaultActiveKey="1"
          items={secondTab}
          onChange={handleTabChange}
          destroyInactiveTabPane={true}
        ></Tabs>
      )}
    </div>
  );
}

export default App;
